
export default {
  name: 'TransportEquipmentCard',

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    name: function () {
      return this.item?.title
    },
    image: function () {
      return String(this.item?.image || this.item?.imageId || this.item?.image_id)
    },
    seoTitle: function () {
      return this.item?.dynamicFields?.seo_title || ""
    }
  }
}
